import { ApiResponse } from "@/api/types";

export const sortPlans = (plans: ApiResponse.Plan[]) =>
  plans.sort((a, b) => a.graduate_year - b.graduate_year || a.id - b.id);
